import { render, staticRenderFns } from "./newlist.vue?vue&type=template&id=01ff7ec2&scoped=true"
import script from "./newlist.vue?vue&type=script&lang=js"
export * from "./newlist.vue?vue&type=script&lang=js"
import style0 from "./newlist.vue?vue&type=style&index=0&id=01ff7ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ff7ec2",
  null
  
)

export default component.exports